import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { getMenus } from "../data-sources/api";
import { uriTransformer } from "./custom-functions/UriTransformer";
import { useStatement } from "./contexts/StatementContext";
import "../styles/NavMenu.css";

/**
 * HeaderMenu component that fetches menu data and displays navigation links.
 * 
 * @returns {JSX.Element} The rendered header menu with dynamic navigation links.
 */
export function HeaderMenu() {
  const [menuItems, setMenu] = useState([]);
  const { clearStatementID } = useStatement();

  /*
   * Fetches menu data on component render
   */
  useEffect(() => {
    getMenus()
      .then((response) => {
        setMenu(response.data);
      })
      .catch((error) => {
        console.error("Error fetching menu data:", error);
      });
  }, []);

  return (
    <header className="nav-header">
      <nav className="nav-menu">
        <ul>
          <li key={0} className="nav-item light-text" tabIndex={0}>
            <NavLink
              to={`/instruktioner`}
              style={{ textDecoration: "none", color: "inherit" }}
              className="nav-link"
            >
              Instruktioner
            </NavLink>
          </li>

          {menuItems.map((menuItem) => (
            <li
              key={menuItem.id}
              className="nav-item light-text"
              tabIndex={menuItem.id}
            >
              <NavLink
                onClick={() => clearStatementID() }
                to={`/${uriTransformer(menuItem.menuText)}`}
                style={{ textDecoration: "none", color: "inherit" }}
                className="nav-link"
              >
                {menuItem.menuText}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
